import React from "react";
import { NoDataAvailableDiv } from "../../../components/NoDataAvailableDiv";
import ViewerRowCard from "./ViewerRowCard";
import { Modal } from "components";
import EditParticipantAsContact from "../modals/EditParticipantAsContact";
import { useSetContactParticipant } from "../Participant/hooks";
import { useMutation } from "@tanstack/react-query";
import { messageTemplateForESignViewer } from "utilities/documentUtils";
import { getCultureFromParticipant } from "utilities/esigningUtils";
import { useContact } from "utilities/hookutils";

interface Props {
  viewers: server.dto.ESignParticipant[]
  onChanged: () => Promise<any>
  document: server.dto.ESignDocument
}

const ViewerList = (props: Props) => {
  const [editingViewer, setEditingViewer] = React.useState<server.dto.ESignParticipant | null>(null);
  const contact = useContact(editingViewer?.contact);

  const deleteMutation = useMutation(window.CoreApi.ESign.DeleteParticipant);

  const onDelete = async (participant: server.dto.ESignParticipant) => {
    if (deleteMutation.isLoading) return;

    await deleteMutation.mutateAsync(participant.eSignParticipantId);
    await props.onChanged();
  };

  const setContactParticipant = useSetContactParticipant(props.document.documentId, "viewer", () => {
    setEditingViewer(null);
    props.onChanged();
  });

  if (props.viewers.length === 0) {
    return <NoDataAvailableDiv />;
  }

  return <>
    <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-body">
        {props.viewers.map((viewer) => (
          <ViewerRowCard
            participant={viewer}
            key={viewer.eSignParticipantId}
            lifeCycle={props.document.lifeCycle.value}
            onDeleteClicked={async () => onDelete(viewer)}
            onEditClicked={() => { setEditingViewer(viewer); }}
          />
        ))}
      </div>
    </div>

    <Modal
      isOpen={editingViewer != null}
      handleClose={() => { setEditingViewer(null); }}
      title={RESX.ESign.Viewer}
      width="small"
    >
      <EditParticipantAsContact
        contactName={contact?.name?.fullName}
        contactId={contact?.contactId}
        initialEmail={editingViewer?.email}
        initialCompany={null}
        initialCulture={getCultureFromParticipant(editingViewer?.linkedToUser, contact)}

        initialInvitationSubject={editingViewer?.invitationSubject}
        initialInvitationBody={editingViewer?.invitationBody}
        saveMutation={setContactParticipant}
        isViewer
        messageTemplateType={messageTemplateForESignViewer(props.document.documentType)}
      />
    </Modal>
  </>;
};

export default ViewerList;